
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Modal } from 'ant-design-vue';

@Component({
    name: 'PriceUpdateNoticeModal',
    components: { 'a-modal': Modal },
})
export default class PriceUpdateNoticeModal extends Vue {
    @Prop({ required: true, default: false }) private visible!: boolean;

    private get internalVisible() {
        return this.visible;
    }

    private set internalVisible(value: boolean) {
        this.$emit('update:visible', value);
    }

    private confirm() {
        this.$emit('update:visible', false);
        this.$emit('confirm');
    }
}
